import React from 'react';
import styled from 'react-emotion';

import { cx } from 'helpers';

// import { BASE_COLOR } from 'shared/constants/colors';


const HotkeyHint = ({ isFocused }) => (
  <div
    contentEditable={false}
    className={cx(
      "absolute w-100 tr moa-ff-sans moon-gray fw3",
      {"o-0": isFocused === false},
    )}
    style={{
      paddingTop: '2px',
      fontSize: '11px',  // Extra tiny
      transition: 'opacity 150ms',
    }}
  >
    ⌘ + Enter to exit
  </div>
);


const CodeBlock = props => {
  const { editor, node } = props;
  const { selection: sel } = editor.value;
  const isFocused = sel.hasStartIn(node) && sel.hasEndIn(node);

  return (
    <pre
      className="relative br1 bg-near-white"
      style={{
        fontSize: '13px',  // About 80 chars in one line
      }}
      {...props.attributes}
    >
      <code className="db pre pa3" spellCheck={false}>
        {props.children}
      </code>

      <HotkeyHint isFocused={isFocused} />
    </pre>
  );
};

const CodeLine = styled('div')(props => ({
  margin: '1px 0',
}));


export {
  CodeBlock,
  CodeLine,
}



// WEBPACK FOOTER //
// ./src/components/slate/nodes/codeBlock.js